/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions } from './FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions,
    FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions';

/**
 * @type FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin
 * 
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin = FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions;

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSON(value as FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions);
    }

    return {};
}

